module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', [_c('dt', {
    staticClass: "ordinary"
  }, [_c('span', [_vm._v("一般报警")]), _c('span', {
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": _vm.hideAlarmComp
    }
  }, [_vm._v("关闭  ")])]), _vm._v(" "), _c('dd', [_c('ul', _vm._l((_vm.alarmInfoList.list), function(alarmInfo, index) {
    return _c('li', [_c('p', [_vm._v("报警号：AL" + _vm._s(alarmInfo.id) + " | " + _vm._s(alarmInfo.almTime))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(alarmInfo.almTypeName) + " | " + _vm._s(alarmInfo.planName))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(alarmInfo.vehicleAccount)), _c('span', [_vm._v(_vm._s(alarmInfo.plateNumber))])]), _vm._v(" "), _c('em', [_vm._v(_vm._s(alarmInfo.almMessage))]), _vm._v(" "), _c('p', [_c('i', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.locating(alarmInfo.deviceId)
        }
      }
    }, [_c('a', [_vm._v("定位")])]), _vm._v(" "), _c('i', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.alarmLive(alarmInfo.id, alarmInfo.vehicleId)
        }
      }
    }, [_c('a', [_vm._v("现场")])]), _vm._v(" "), _c('i', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.checkTop({
            id: alarmInfo.id,
            type: 2,
            pageNo: _vm.alarmInfoList.pageNum,
            top: alarmInfo.isStick
          })
        }
      }
    }, [_c('a', [_vm._v(_vm._s(alarmInfo.isStick === 1 ? '已置顶' : '置顶'))])]), _vm._v(" "), _c('i', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleAlarm(alarmInfo.id, 2)
        }
      }
    }, [_c('a', [_vm._v(_vm._s(alarmInfo.handleStatus == 0 ? '处理' : '已处理'))])])])])
  }), 0), _vm._v(" "), _c('laypage', {
    staticClass: "laypage",
    attrs: {
      "pages": _vm.pagesTotal,
      "jump": _vm.cb2,
      "groups": _vm.pagesTotal > 3 ? 3 : _vm.pagesTotal,
      "first": _vm.first,
      "last": _vm.last,
      "prev": _vm.prev,
      "next": _vm.next
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b52c0da","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/layouts/VehicleAlarmOrd.vue
// module id = 1409
// module chunks = 0